import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export const TeamCard = (props) => {
    return (
        <Card sx={{ maxWidth: 300 }} >
            <div style={{ minHeight: 80 }}>
                <Typography style={{ padding: 16, fontSize: 26 }} component="div">
                    {props.title}
                </Typography>
            </div>
            <CardHeader
                avatar={
                    <img style={{ width: 100, height: 100 }} src={props.hover ? props.altIcon : props.icon} aria-label="recipe" />
                }
                title={props.name}
                subheader={props.role}
            />
            <CardContent>
                <Typography variant="body2" sx={{ color: 'text.secondary' }} class="bubble bubble-bottom-left">
                    {props.content}
                </Typography>
            </CardContent>
        </Card>
    );
}